class SideDrawer extends HTMLElement {
  constructor() {
    super();

    const thisElement = this;

    this.addEventListener("drawer-toggle", () =>
      this.classList.contains("drawer--active")
        ? thisElement.close(this)
        : thisElement.open(this)
    );

    this.addEventListener("keyup", evt => evt.code === "Escape" && this.close());
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.calculateHeights();

    window.addEventListener("resize", () => this.calculateHeights());

    document.addEventListener('calculate-header-height', this.calculateHeaderHeight);
    document.addEventListener('calculate-announcement-height', this.calculateAnnouncementHeight);
  }

  open(drawer) {
    document.dispatchEvent(new Event("calculate-header-height"));

    this.classList.add("drawer--active");

    if (window.scrollY > 0) document.body.classList.add('body--scrolled');

    document.body.classList.add("shadow");
    document.body.style.top = `-${window.scrollY}px`;
    document.body.style.position = "fixed";

    this.addEventListener("transitionend", () => {
      drawer.focus();
      trapFocus(drawer);
    },
    { once: true });

    document.body.addEventListener("click", this.onBodyClick, {
      passive: true,
    });

    // Close Search
    const toggleSearch = new Event("toggle-search");

    document.dispatchEvent(toggleSearch);
  }

  close() {
    this.classList.remove("drawer--active");

    const activeDrawers = document.querySelectorAll("side-drawer.drawer--active");

    if (!activeDrawers.length) {
      document.body.classList.remove("shadow");

      const scrollY = document.body.style.top;

      document.body.style.top = "";
      document.body.style.position = "";

      window.scrollTo(0, parseInt(scrollY || 0) * -1);

      document.body.removeEventListener("click", this.onBodyClick, { passive: true });

      setTimeout(() => document.body.classList.remove('body--scrolled'), 200);
    }

    removeTrapFocus(this);
  }

  handleBodyClick(evt) {
    const target = evt.target;

    if (target !== this && !target.closest("side-drawer") && !target.closest("side-drawer-toggle")) {
      const burger = document.querySelector(`side-drawer-toggle[data-drawer=${this.id}]`);

      if (burger) burger.classList.remove('active');

      this.close();
    }
  }

  calculateHeights() {
    this.calculateDrawerHeight();
    this.calculateHeaderHeight();
    this.calculateAnnouncementHeight();
  }

  calculateDrawerHeight() {
    document.documentElement.style.setProperty(
      "--app-height",
      `${window.innerHeight}px`
    );
  }

  calculateHeaderHeight() {
    const header = document.querySelector('.header-wrapper .header');

    document.documentElement.style.setProperty(
      "--mobile-header-height",
      `${header.clientHeight}px`
    );
  }

  calculateAnnouncementHeight() {
    const announcement = document.querySelector('.header-wrapper .announcement-bar');

    document.documentElement.style.setProperty(
      "--announcement-height",
      `${announcement.clientHeight}px`
    );
  }
}

customElements.define("side-drawer", SideDrawer);
